<template>
  <div>
    <div class="container">
      <div class="handle-box">

        <el-select size="small" v-model="agentId" clearable filterable placeholder="选择代理" style="width: 180px;" class="handle-input mr10" @change="onAgentChange">
          <el-option v-for="item in agentOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
        <el-select size="small" v-model="companyId" clearable filterable placeholder="选择企业" style="width: 200px;" class="handle-input mr10">
          <el-option v-for="item in companyOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
        <el-select size="small" v-model="packagesName" clearable filterable placeholder="选择套餐" style="width: 300px;" class="handle-input mr10">
          <el-option :value="null" label="全部套餐"></el-option>
          <el-option v-for="item in packagesOptions" :key="item" :label="item" :value="item"></el-option>
        </el-select>
        <el-date-picker
            v-model="dateRange"
            align="right"
            size="small"
            type="monthrange"
            range-separator="至"
            start-placeholder="开始月份"
            end-placeholder="结束月份"
            value-format="yyyy-MM"
            class="handle-input mr10"
        ></el-date-picker>
        <el-button size="small" type="primary" :class="[theme]" icon="el-icon-search" @click="getData">查询</el-button>
        <el-button size="small" type="success" :class="[theme]" icon="el-icon-download" @click="handleExport">导出</el-button>
      </div>

      <div v-if="summaryData" class="summary-box">
        <div class="summary-row">
          <div class="summary-item">
            <div class="item-label">购买次数</div>
            <div class="item-value">{{ summaryData.totalPurchaseCount }}</div>
          </div>
          <div class="summary-item">
            <div class="item-label">总充值</div>
            <div class="item-value">{{ (summaryData.sumTotalRechargeAmount || 0).toFixed(2) }}</div>
          </div>
          <div class="summary-item">
            <div class="item-label">总截留</div>
            <div class="item-value">{{ (summaryData.sumTotalNeedIntercept || 0).toFixed(2) }}</div>
          </div>
          <div class="summary-item">
            <div class="item-label">总到账</div>
            <div class="item-value">{{ (summaryData.sumTotalArrivalAmount || 0).toFixed(2) }}</div>
          </div>
          <div class="summary-item">
            <div class="item-label">实际充值</div>
            <div class="item-value">{{ (summaryData.sumActualRechargeAmount || 0).toFixed(2) }}</div>
          </div>
          <div class="summary-item">
            <div class="item-label">实际截留</div>
            <div class="item-value">{{ (summaryData.sumActualNeedIntercept || 0).toFixed(2) }}</div>
          </div>
          <div class="summary-item">
            <div class="item-label">实际到账</div>
            <div class="item-value">{{ (summaryData.sumActualArrivalAmount || 0).toFixed(2) }}</div>
          </div>
        </div>
      </div>

      <el-table
        :key="tableKey"
        :data="tableData"
        border
        class="table"
        max-height="600"
        :row-style="{ height: '20px' }"
        :cell-style="{ padding: '6px' }"
        :header-cell-style="{ 'text-align': 'center' }"
        stripe
        v-loading="loading"
        style="cursor: default;"
      >
        <el-table-column prop="yearMonth" label="月份" width="120" align="center"></el-table-column>
        <el-table-column prop="packagesName" label="迪信通套餐名称" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="sjtxPackagesName" label="世纪通信套餐名称" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="packageType" label="套餐类型" width="120" align="center">
          <template #default="scope">
            <span v-if="scope.row.packageType == 0">整月套餐</span>
            <span v-else-if="scope.row.packageType == 1">首月上下半月</span>
            <span v-else>{{ scope.row.packageType }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="sjtxPriceSnapshot" label="世纪通信价格(元)" width="150" align="center" sortable>
          <template #default="scope">
            {{ scope.row.sjtxPriceSnapshot !== null ? scope.row.sjtxPriceSnapshot.toFixed(2) : '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="dxtPriceSnapshot" label="迪信通价格(元)" width="130" align="center" sortable>
          <template #default="scope">
            {{ scope.row.dxtPriceSnapshot !== null ? scope.row.dxtPriceSnapshot.toFixed(2) : '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="purchaseCount" label="购买次数" width="100" align="center" sortable></el-table-column>
        <el-table-column prop="totalRechargeAmount" label="总充值金额(元)" width="130" align="center" sortable>
          <template #default="scope">
            {{ scope.row.totalRechargeAmount !== null ? scope.row.totalRechargeAmount.toFixed(2) : '0.00' }}
          </template>
        </el-table-column>
        <el-table-column prop="totalNeedIntercept" label="总截留金额(元)" width="130" align="center" sortable>
          <template #default="scope">
            {{ scope.row.totalNeedIntercept !== null ? scope.row.totalNeedIntercept.toFixed(2) : '0.00' }}
          </template>
        </el-table-column>
        <el-table-column prop="totalArrivalAmount" label="总到账金额(元)" width="130" align="center" sortable>
          <template #default="scope">
            {{ scope.row.totalArrivalAmount !== null ? scope.row.totalArrivalAmount.toFixed(2) : '0.00' }}
          </template>
        </el-table-column>
        <el-table-column prop="actualRechargeAmount" label="实际充值金额(元)" width="140" align="center" sortable>
          <template #default="scope">
            {{ scope.row.actualRechargeAmount !== null ? scope.row.actualRechargeAmount.toFixed(2) : '0.00' }}
          </template>
        </el-table-column>
        <el-table-column prop="actualNeedIntercept" label="实际截留金额(元)" width="140" align="center" sortable>
          <template #default="scope">
            {{ scope.row.actualNeedIntercept !== null ? scope.row.actualNeedIntercept.toFixed(2) : '0.00' }}
          </template>
        </el-table-column>
        <el-table-column prop="actualArrivalAmount" label="实际到账金额(元)" width="140" align="center" sortable>
          <template #default="scope">
            {{ scope.row.actualArrivalAmount !== null ? scope.row.actualArrivalAmount.toFixed(2) : '0.00' }}
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import { getAccountStatistics, getDxtPackagesOfNumber, exportAccountStatistics, getCompaniesWithRecords } from '../../api/dijia.js';
import { fetchAgent } from '../../api/agentIndex.js';
import { fetchCompanyByAgentId } from '../../api/companyIndex.js';

export default {
  name: 'DxtAccountStatistics',
  data() {
    return {
      loading: false,
      theme: localStorage.getItem('theme'),
      dateRange: null,
      packagesName: null,
      agentId: null,
      companyId: null,
      packagesOptions: [],
      agentOptions: [],
      companyOptions: [],
      tableData: [],
      summaryData: null,
      tableKey: 0
    };
  },
  created() {
    this.loadPackages();
    this.loadAgents();
  },
  methods: {
    loadPackages() {
      getDxtPackagesOfNumber().then(res => {
        if (res?.code === 200) {
          this.packagesOptions = (res.data || []).map(item => item.packagesName).filter(Boolean);
        }
      });
    },
    loadAgents() {
      fetchAgent(localStorage.getItem('user')).then(res => {
        if (res?.code === 200) {
          this.agentOptions = res.data || [];
        }
      });
    },
    onAgentChange() {
      this.companyId = null;
      this.companyOptions = [];
      if (this.agentId) {
        // 调用新接口，只查询有账务记录的企业
        getCompaniesWithRecords(this.agentId).then(res => {
          if (res?.code === 200) {
            this.companyOptions = res.data || [];
          }
        }).catch(err => {
          console.error(err);
          // 出错时回退到旧接口
          fetchCompanyByAgentId({ agentId: this.agentId, subAgent: false }).then(res => {
            if (res?.code === 200) {
              this.companyOptions = res.data || [];
            }
          });
        });
      }
    },
    getData() {
      this.loading = true;
      const startYearMonth = this.dateRange && this.dateRange.length === 2 ? this.dateRange[0] : null;
      const endYearMonth = this.dateRange && this.dateRange.length === 2 ? this.dateRange[1] : null;
      getAccountStatistics(startYearMonth, endYearMonth, this.packagesName || null, this.agentId || null, this.companyId || null).then(res => {
        if (res?.code === 200) {
          this.tableData = res.data.statistics || [];
          this.summaryData = res.data.summary || null;
          this.tableKey++;
        } else {
          this.$message.error(res.message || '查询失败');
        }
        this.loading = false;
      }).catch(err => {
        this.loading = false;
        this.$message.error('查询失败');
        console.error(err);
      });
    },
    handleExport() {
      const startYearMonth = this.dateRange && this.dateRange.length === 2 ? this.dateRange[0] : null;
      const endYearMonth = this.dateRange && this.dateRange.length === 2 ? this.dateRange[1] : null;
      
      exportAccountStatistics(startYearMonth, endYearMonth, this.packagesName || null, this.agentId || null, this.companyId || null)
        .then(res => {
          if (!res) {
            this.$message.error('导出失败');
            return;
          }
          
          // 创建 Blob 对象并下载
          const blob = new Blob([res], { 
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
          });
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = '账务统计_' + new Date().toISOString().slice(0,10) + '.xlsx';
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          window.URL.revokeObjectURL(url);
          
          this.$message.success('导出成功');
        })
        .catch(err => {
          console.error(err);
          this.$message.error('导出失败');
        });
    }
  }
};
</script>

<style scoped>
.handle-box {
  margin-bottom: 15px;
}

.summary-box {
  margin-bottom: 15px;
}

.summary-row {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.summary-item {
  flex: 1;
  min-width: 100px;
  text-align: center;
  padding: 10px;
  background: #f5f7fa;
  border-radius: 4px;
}

.item-label {
  color: #909399;
  font-size: 12px;
  margin-bottom: 5px;
}

.item-value {
  color: #303133;
  font-size: 16px;
  font-weight: bold;
}
</style>
